module.exports = __webpack_public_path__ + "img/item-4-3.b7998ba3.png";